/**
 * PermissionRoute - Компонент для защиты маршрутов по разрешениям
 *
 * Проверяет наличие необходимых прав перед отображением контента.
 * Если прав нет - показывает страницу AccessDeniedPage.
 */
import React from 'react';
import { usePermissions } from '../hooks/usePermissions';
import AccessDeniedPage from '../pages/AccessDeniedPage';

/**
 * @param {string} permission - Требуемое разрешение (например, 'users:read')
 * @param {string[]} anyOf - Массив разрешений, достаточно одного из них
 * @param {string[]} allOf - Массив разрешений, нужны все
 * @param {string} message - Кастомное сообщение для страницы "Доступ запрещен"
 * @param {React.ReactNode} children - Содержимое маршрута
 */
const PermissionRoute = ({
  permission,
  anyOf,
  allOf,
  message,
  children,
}) => {
  const { hasPermission, hasAnyPermission, hasAllPermissions } = usePermissions();

  let hasAccess = false;

  if (permission) {
    hasAccess = hasPermission(permission);
  } else if (anyOf && anyOf.length > 0) {
    hasAccess = hasAnyPermission(anyOf);
  } else if (allOf && allOf.length > 0) {
    hasAccess = hasAllPermissions(allOf);
  } else {
    // Если никакие разрешения не указаны - разрешаем доступ
    hasAccess = true;
  }

  if (!hasAccess) {
    return <AccessDeniedPage message={message} />;
  }

  return children;
};

export default PermissionRoute;
